import { useState, type FormEvent } from 'react';
import { CheckCircle2, KeyRound } from 'lucide-react';
import { useNavigate, useSearchParams } from '../../app/router';
import { Logo } from '../../components/Logo';
import { ApiError, apiRequest } from '../../lib/api';

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (password !== confirmation) {
      setError('Lozinke se ne podudaraju.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await apiRequest('/api/v1/auth/password-reset/confirm', {
        method: 'POST',
        body: JSON.stringify({ token, password })
      });
      setSuccess(true);
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : 'Novu lozinku nije moguće spremiti.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="admin-login">
      <section className="login-card admin-login__card">
        <Logo />
        {success ? (
          <>
            <span className="success-mark"><CheckCircle2 size={30} /></span>
            <h1>Lozinka je promijenjena</h1>
            <p className="muted">Sve stare sesije su odjavljene. Prijavite se novom lozinkom.</p>
            <button className="button button--primary button--large" onClick={() => navigate('/login?passwordChanged=1')}>
              Nastavi na prijavu
            </button>
          </>
        ) : (
          <form className="activation-form" onSubmit={submit}>
            <span className="admin-badge"><KeyRound size={16} /> Oporavak računa</span>
            <h1>Postavite novu lozinku</h1>
            <p className="muted">Najmanje 12 znakova, veliko i malo slovo te broj.</p>
            <label className="field"><span>Nova lozinka</span><span className="field__control"><input type="password" autoComplete="new-password" minLength={12} value={password} onChange={(event) => setPassword(event.target.value)} required /></span></label>
            <label className="field"><span>Ponovite lozinku</span><span className="field__control"><input type="password" autoComplete="new-password" minLength={12} value={confirmation} onChange={(event) => setConfirmation(event.target.value)} required /></span></label>
            {!token && <div className="form-error">Token za novu lozinku nedostaje.</div>}
            {error && <div className="form-error">{error}</div>}
            <button className="button button--primary button--large" disabled={loading || !token}>{loading ? 'Spremam…' : 'Spremi novu lozinku'}</button>
          </form>
        )}
      </section>
    </main>
  );
}
